import { render } from "./AuthModal.vue?vue&type=template&id=7f40ba8f&scoped=true&ts=true"
import script from "./AuthModal.vue?vue&type=script&lang=ts"
export * from "./AuthModal.vue?vue&type=script&lang=ts"

import "./AuthModal.vue?vue&type=style&index=0&id=7f40ba8f&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f40ba8f"]])

export default __exports__